import React from 'react';
import classnames from 'classnames';
import './FeedbackTab.less';

export default function FeedbackTab(props) {
    const classNames = classnames(props.className, {
        [`Feedback Feedback--${props.tabPosition}`]: !props.className
    });

    return (
        <React.Fragment>
            {props.children}
            <div id="Feedback" className={classNames}>
                <div
                    aria-label={props.tabText}
                    aria-haspopup="true"
                    aria-expanded={props.isOpen}
                    role="button"
                    tabIndex="0"
                    onClick={props.onClick}
                    onKeyPress={props.onPress}
                    className={props.feedbackTabClassList}
                >
                    {props.tabText}
                </div>
            </div>
        </React.Fragment>
    );
}
